<div class="ex__note ex__note--{{ selectedView }}" *ngIf="selectedView !== 'list'" (click)="stopPropagation($event)">
    <div class="ex__note-header">
        <div class="icon-container">
            <img class="pointer action-note" width="30" height="30" [alt]="'description'"  src="assets/img/description.svg">
            <span>Mis notas</span>
        </div>
        <img class="pointer action-close" (click)="closeNote(item, $event)" width="24" height="24" [alt]="'close'" src="assets/img/close.svg">
    </div>
    <textarea name="note" class="description_textarea" [(ngModel)]="item.note"></textarea>
    <div class="ex__note-footer">
        <img class="pointer action-note" (click)="removeNote(item, $event)" width="24" height="24" [alt]="'delete'" src="assets/img/delete.svg">
        <span class="pointer save-txt" (click)="saveNote(item, $event)">{{ 'EXHIBITOR.SAVE' | translate }}</span>
    </div>
</div>

<div class="ex__note ex__note--{{ selectedView }}" *ngIf="selectedView === 'list'" (click)="stopPropagation($event)">
    <div class="ex__note-header">
        <div class="icon-container">
            <img class="pointer action-note" width="30" height="30" [alt]="'description'" src="assets/img/description.svg">
            <span>{{ 'EXHIBITOR.MY_NOTES' | translate }}</span>
        </div>
        <textarea name="note" class="description_textarea" [(ngModel)]="item.note"></textarea>
    </div>
    <div class="ex__note-footer">
        <div class="icon-container pointer" (click)="closeNote(item, $event)">
            <img class="pointer action-close" width="24" height="24" [alt]="'close'" src="assets/img/close.svg">
            <span>{{ 'EXHIBITOR.CLOSE' | translate }}</span>
        </div>
        <div class="icon-container pointer" (click)="saveNote(item, $event)">
            <img class="pointer action-close" width="24" height="24" [alt]="'save'" src="assets/img/save.svg">
            <span>{{ 'EXHIBITOR.SAVE' | translate }}</span>
        </div>
        <div class="icon-container pointer" (click)="removeNote(item, $event)">
            <img class="pointer action-note" width="24" height="24" [alt]="'delete'" src="assets/img/delete.svg">
            <span>{{ 'EXHIBITOR.DELETE' | translate }}</span>
        </div>
    </div>
</div>
